import React from "react";
import { Link } from "react-router-dom";

const PageNotFound = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0f172a] via-[#0b1d3a] to-[#020617] text-white px-4">
      <div className="text-center max-w-lg">
        <svg
          width="220"
          height="220"
          viewBox="0 0 200 200"
          className="mx-auto mb-6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="100" cy="100" r="90" fill="#1e3a8a" opacity="0.25" />
          <circle cx="100" cy="100" r="70" fill="#2563eb" opacity="0.35" />
          <text
            x="50%"
            y="55%"
            textAnchor="middle"
            fill="#fff"
            fontSize="48"
            fontWeight="bold"
          >
            404
          </text>
        </svg>

        <h1 className="text-3xl font-bold mb-2">Page Not Found</h1>
        <p className="text-gray-300 mb-6">
          Sorry, the page you are looking for doesn’t exist or has been moved.
        </p>

        <Link
          to="/"
          className="inline-block px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-700 transition font-medium shadow-lg"
        >
          Go Back Home
        </Link>
      </div>
    </div>
  );
};

export default PageNotFound;